module.exports = __webpack_public_path__ + "media/images/flags/1x1/pry-c9326f6545717639c50643b3e9548149.svg";